import { gql } from "@apollo/client";
import { CreatedBagInfo, BagType } from "../types/ConsolidationTypes";

export const EXECUTE_CONSOLIDATION = gql`
    mutation ExecuteConsolidation($input: ExecuteConsolidationTypeInput!) {
        executeConsolidation(input: $input) {
            success
            taskId
            createdBagCount
            processedOrderCount
            createdBags {
                bagId
                bagNumber
                bagCode
                actualParcelCount
            }
            message
        }
    }
`;

export interface ExecuteConsolidationVariables {
    input: {
        warehouseId: string;
        destinationHubId?: string;
        destinationHubName?: string;
        destinationWhsId?: string | null;
        destinationWhsName?: string;
        expectedDeliveryTimeStart?: string;
        expectedDeliveryTimeEnd?: string;
        bagType?: BagType;
        carrier?: number; // 新增carrier字段，用于Other Carrier
    };
}

export interface ExecuteConsolidationResponse {
    executeConsolidation: {
        success: boolean;
        taskId?: string;
        createdBagCount: number;
        processedOrderCount: number;
        createdBags: CreatedBagInfo[];
        message?: string;
    };
} 